import {
	ChangeDetectionStrategy,
	Component,
	Input,
} from '@angular/core';

import { CARD_PICTURE } from 'ib/internetbank-core/ib-constants/size';

import {
	StatementDTO,
	StatementItemDTO,
	StatementStatuses,
} from '../statements-model';

@Component({
	selector: 'app-statement-item',
	templateUrl: './statement-item.component.html',
	styleUrls: ['./statement-item.component.less'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})

export class StatementItemComponent {

	@Input()
	public title: string;

	@Input()
	public item: StatementItemDTO;

	public statementData: StatementDTO;
	public StatementStatuses: typeof StatementStatuses = StatementStatuses;
	public CARD_PICTURE: typeof CARD_PICTURE = CARD_PICTURE;

}
